import { render } from "./TramitesEstadisticas.vue?vue&type=template&id=26f66e8c&scoped=true"
import script from "./TramitesEstadisticas.vue?vue&type=script&lang=js"
export * from "./TramitesEstadisticas.vue?vue&type=script&lang=js"

import "./TramitesEstadisticas.vue?vue&type=style&index=0&id=26f66e8c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f66e8c"]])

export default __exports__